import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=5d759b5d&scoped=true"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d759b5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d759b5d')) {
      api.createRecord('5d759b5d', component.options)
    } else {
      api.reload('5d759b5d', component.options)
    }
    module.hot.accept("./ViewForm.vue?vue&type=template&id=5d759b5d&scoped=true", function () {
      api.rerender('5d759b5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/distribution/ratio/components/ViewForm.vue"
export default component.exports